import React, { useEffect, useState } from 'react';
import { getProfile } from '../../services/profile';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getProfile();
        setProfile(data?.data);
      } catch (err) {
        setError(err?.message || 'Failed to load profile');
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  if (!profile) {
    return null;
  }

  return (
    <div className="max-w-4xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Profile</h1>
      
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 h-32"></div>
        
        <div className="px-6 pb-6">
          <div className="flex items-center -mt-16 mb-6">
            <div className="w-32 h-32 bg-white rounded-full border-4 border-white shadow-lg flex items-center justify-center">
              <span className="text-5xl font-bold text-blue-500">
                {profile.first_name?.[0]}{profile.last_name?.[0]}
              </span>
            </div>
            <div className="ml-6 mt-16">
              <h2 className="text-2xl font-bold text-gray-900">
                {profile.first_name} {profile.last_name}
              </h2>
              <p className="text-gray-600">{profile.email}</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">First Name</label>
                <p className="text-gray-900 mt-1">{profile.first_name}</p>
              </div>
              
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">Last Name</label>
                <p className="text-gray-900 mt-1">{profile.last_name}</p>
              </div>
              
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">Email</label>
                <p className="text-gray-900 mt-1">{profile.email}</p>
              </div>
              
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">Phone Number</label>
                <p className="text-gray-900 mt-1">{profile.phone_number}</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">Role</label>
                <p className="text-gray-900 mt-1">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                    {profile.role}
                  </span>
                </p>
              </div>
              
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">Verification Status</label>
                <p className="text-gray-900 mt-1">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                    profile.is_verified ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                  }`}>
                    {profile.is_verified ? '✓ Verified' : '⚠ Not Verified'}
                  </span>
                </p>
              </div>
              
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">Account Status</label>
                <p className="text-gray-900 mt-1">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                    profile.is_locked ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
                  }`}>
                    {profile.is_locked ? '🔒 Locked' : '🔓 Active'}
                  </span>
                </p>
              </div>
              
              <div className="border-b pb-3">
                <label className="text-sm font-medium text-gray-500">Member Since</label>
                <p className="text-gray-900 mt-1">
                  {new Date(profile.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;